module.exports = __webpack_public_path__ + "img/usb.7cf0eb70.png";